import { memo, useState } from "react";
import Demo from "./Demo/Demo";
import Name from "./Name/Name";
import Highlight from "./Highlight/Highlight";
import { FixaListView } from "@coworker/apprestructured/src/shared/wrappers/FixaListView/FixaListView";
import AddLinks from "@coworker/apprestructured/src/task-management/components/AddLinks/AddLinks";
import Actions from "./Actions/Actions";
import FixaCheckbox from "@coworker/apprestructured/src/shared/wrappers/FixaCheckbox/FixaCheckbox";

function AddLinksDemo() {
  const [links, setLinks] = useState<string[]>([]);
  const [disabled, setDisabled] = useState(false);

  return (
    <Demo>
      <Name>AddLinks</Name>
      <Highlight>
        <FixaListView id="addlinks" size="small">
          <AddLinks
            links={links}
            onLinksChanged={setLinks}
            disabled={disabled}
          />
        </FixaListView>
      </Highlight>
      <Actions>
        <FixaCheckbox
          label="disabled"
          value="addlinksdemo-disabled"
          id="addlinksdemo-disabled"
          checked={disabled}
          onChange={() => setDisabled((prev) => !prev)}
        />
      </Actions>
    </Demo>
  );
}

export default memo(AddLinksDemo);
